export enum SelectionOption {
  Opportunities,
  OpportunityMode,
}
